/** A PDF export problem does not replace or hide the readable report. */
export function reportPdfDeliveryNotice(report: {
  id: string;
  pdfDelivery?: { status: 'not-requested' | 'failed' | 'ready'; adminIssueId?: string };
}): string | null {
  if (report.pdfDelivery?.status !== 'failed') return null;
  return 'PDF download is temporarily unavailable. You can continue reading this report.'
    + (report.pdfDelivery.adminIssueId ? ' The administrator has been notified.' : '');
}
